import { create } from 'zustand';
import type { Role } from '../hooks/useAuth';

export interface User {
  id: number;
  username: string;
  displayName: string;
  role: Role;
  scopeChannelId: number | null;
}

interface AuthState {
  token: string | null;
  user: User | null;
  setAuth: (token: string, user: User) => void;
  logout: () => void;
  updateUser: (user: Partial<User>) => void;
}

// Load from localStorage
const storedToken = localStorage.getItem('zhibao_token');
const storedUser = localStorage.getItem('zhibao_user');

export const useAuthStore = create<AuthState>((set) => ({
  token: storedToken,
  user: storedUser ? JSON.parse(storedUser) : null,

  setAuth: (token: string, user: User) => {
    localStorage.setItem('zhibao_token', token);
    localStorage.setItem('zhibao_user', JSON.stringify(user));
    set({ token, user });
  },

  logout: () => {
    localStorage.removeItem('zhibao_token');
    localStorage.removeItem('zhibao_user');
    set({ token: null, user: null });
  },

  updateUser: (partial: Partial<User>) => {
    set((state) => {
      const newUser = state.user ? { ...state.user, ...partial } : null;
      if (newUser) localStorage.setItem('zhibao_user', JSON.stringify(newUser));
      return { user: newUser };
    });
  },
}));
